import { observer, Switch } from '@legendapp/state/react';
import { TFLoadingOverlay } from '@tf/ui';
import type React from 'react';
import { AppFormBuilder, ModalFooter } from '@/components/shared';
import { useAccountForm } from '@/core/hooks';

interface Props {
	onClose: () => void;
}

export const RiskProfileForm: React.FC<Props> = observer(({ onClose }) => {
	const { state, scripts, formSegments, handleSubmit } = useAccountForm(['COMMON__COMPLIANCE_FEEDBACK'], {
		onSuccess: onClose,
	});

	return (
		<Switch value={state.values}>
			{{
				undefined: () => <TFLoadingOverlay h={300} size={24} />,
				default: () => (
					<AppFormBuilder
						styles={{ content: { padding: '.25rem .75rem' } }}
						segments={formSegments}
						processingScripts={scripts}
						shouldValidate
						initialValues={state.values?.get() ?? {}}
						onSubmit={handleSubmit}
						submitButtonRenderer={(isLoading) => (
							<ModalFooter submitText="Save changes" isDisabled={isLoading} onCancel={onClose} />
						)}
					/>
				),
			}}
		</Switch>
	);
});
